var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "raft-js"
    }
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('router-view'), _vm._v(" "), _c('notifications', {
    attrs: {
      "position": "bottom right",
      "group": "alerts"
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }